import script from "./InforList.vue?vue&type=script&setup=true&lang=ts"
export * from "./InforList.vue?vue&type=script&setup=true&lang=ts"

import "./InforList.vue?vue&type=style&index=0&id=5e9cd20d&lang=scss"

const __exports__ = script;

export default __exports__